import Resource from '../Resource'

export default class PreTestAnswer extends Resource {
  static ENDPOINT = '/api/test/pre/pretestanswer'

  constructor (args) {
    super()
    if (args) {
      Object.keys(args).forEach(arg => {
        this[arg] = args[arg]
      })
    }
  }

  static create (training, category, student, test) {
    const qs = test.questions
    const answers = Array(qs.length)
    for (let i = 0; i < answers.length; i++) {
      answers[i] = {
        answer: 0,
        code: qs[i].code
      }
    }
    const score = 0
    return new PreTestAnswer({ training, category, student, answers, score })
  }

  mark (test) {
    this.score = 0
    this.correctCount = 0
    for (let i = 0; i < test.questions.length; i++) {
      if (test.questions[i].answer === this.answers[i].answer) {
        this.answers[i].correct = true
        this.answers[i].score = test.questions[i].assignScore
        this.score += test.questions[i].assignScore
        this.correctCount++;
      } else {
        this.answers[i].correct = false
      }
    }
  }
}
